export const drsPanelWorkshops = [
  {
    "Unique ID": 481,
    Name: "Bengkel Memateri Kenderaan Tek Yee Sdn Bhd",
    Address:
      "Ptd 11769, Jalan Industri 2\nTmn Perindustrian\n81500\nPekan Nanas\nJohor Darul Takzim",
    Tel: "07- 699 2207\n07- 699 1803",
    Fax: "07- 699 6520",
    Email: "tekyee@yahoo.com",
    Area: "PEKAN NENAS",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 482,
    Name: "Eng Hong Welding Workshop Sdn Bhd",
    Address:
      "Lot 738 (Pos 50)\nJalan Jeram Tepi Bakri\n84000\nMuar\nJohor Darul Takzim",
    Tel: "60- 6986 9244",
    Fax: "06- 986 0999",
    Email: "ehwwsb@hotmail.com",
    Area: "MUAR",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 483,
    Name: "Sin Heng Auto Works Sdn Bhd",
    Address:
      "No.9, Jalan Permatang 17\nTaman Desa Jaya\n81100\nJohor Bahru\nJohor Darul Takzim",
    Tel: "07- 356 0010",
    Fax: "07- 356 0012",
    Email: "sinheng_workshop@hotmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 484,
    Name: "Soon Lee Welder & Spraying Works Sdn Bhd",
    Address:
      "No 1, Jalan Teknologi 1\nKawasan Perindustrian Mengkibol\n86000\nKluang\nJohor Darul Takzim",
    Tel: "07- 772 6832",
    Fax: "07- 772 7841",
    Email: "soonleewelder@yahoo.com",
    Area: "KLUANG",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 485,
    Name: "Yong Hup Soon Motorworks Sdn Bhd",
    Address:
      "No.1, Jalan Budi 4\nTaman Perindustrian Wawasan 2020\n83000\nBatu Pahat\nJohor Darul Takzim",
    Tel: "07- 428 8727 \n07- 428 8728",
    Fax: "07- 4288726",
    Email: "yhs_claim@hotmail.my",
    Area: "BATU PAHAT",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 943,
    Name: "Nanmar Motor Service Sdn Bhd",
    Address:
      "No. 32, Jalan Seroja 37,\nTaman Johor Jaya\n81100 Johor Bahru\nJohor",
    Tel: "07- 355 7952\n07- 351 8890",
    Fax: "07- 355 7253",
    Email: "nanmarnms@gmail.com",
    Area: "JOHOR BAHRU",
    Status: 1,
    State: "Johor",
  },
  {
    "Unique ID": 476,
    Name: "Juta Oven Spray Painting Sdn Bhd",
    Address:
      "No.91 Jalan Timur 6\nKawasan Perusahaan Mergong Barrage\n05050\nAlor Setar\nKedah Darul Aman",
    Tel: "04- 733 5715",
    Fax: "04- 733 9668",
    Email: "jutaoven@hotmail.com",
    Area: "ALOR SETAR",
    Status: 1,
    State: "Kedah",
  },
  {
    "Unique ID": 490,
    Name: "Unity Accident Repairs Malaysia Sdn Bhd",
    Address:
      "No. 29, Lot 337, Seksyen 92\nJalan 2, Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 8488 \n03- 9221 6488\n03- 9221 5488 ",
    Fax: "03- 9221 2478",
    Email: "customer@unitycorpasia.com",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 491,
    Name: "WTF Auto Services Sdn Bhd",
    Address:
      "No.23A, Jalan Empat\nOff Jalan Chan Sow Lin\n55200 Kuala Lumpur\nWilayah Persekutuan",
    Tel: "03- 9221 3997\n03- 9221 0997\n03- 9221 0998",
    Fax: "03- 9221 7996",
    Email: "tkwong@wtfauto.com.my\ninfo@wtfauto.com.my",
    Area: "KUALA LUMPUR",
    Status: 1,
    State: "Kuala Lumpur",
  },
  {
    "Unique ID": 480,
    Name: "Uni K.S Mudguard Sdn Bhd",
    Address: "No.54& 56, Jalan Berkat 8\nTaman Malim Jaya\n75250\nMelaka",
    Tel: "06- 335 3091\n06- 335 0092",
    Fax: "06- 3353091",
    Email: "uniksmudguard@gmail.com",
    Area: "MELAKA",
    Status: 1,
    State: "Malacca",
  },
  {
    "Unique ID": 492,
    Name: "Ar Shieng Sdn Bhd",
    Address:
      "T-205,Senawang Light\nJalan Tampin\n70450\nSeremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 5984\n06- 677 5985\n06- 677 5986",
    Fax: "06- 678 3966",
    Email: "arshieng@yahoo.com",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 493,
    Name: "Suen Fatt Workshop Sdn Bhd",
    Address:
      "Lot 30927, Bt 9, Jalan Besar\n71700\nMantin\nNegeri Sembilan Darul Khusus",
    Tel: "06- 758 6333\n06- 758 7333\n06- 758 1364\n06- 7581563",
    Fax: "06- 758 2821\n06- 758 3563",
    Email: "info@suenfatt.com",
    Area: "MANTIN",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 494,
    Name: "Chee Kong Motor Sdn Bhd",
    Address:
      "PT 2103 & 2104, S.H. (D) 71923\nSri Senawang Light Industri Centre\n70450\nSeremban\nNegeri Sembilan Darul Khusus",
    Tel: "06- 677 1889\n06- 677 3889",
    Fax: "06- 678 1681\n06- 677 1350",
    Email: "choywan@cheekongmotor.com.my",
    Area: "SENAWANG",
    Status: 1,
    State: "Negeri Sembilan",
  },
  {
    "Unique ID": 486,
    Name: "Hoi Keen Auto Spray Sdn Bhd",
    Address:
      "No.A551, Jalan Padang Lalang\n25050\nKuantan\nPahang Darul Makmur",
    Tel: "09- 516 1898\n09- 516 2471",
    Fax: "09- 516 5898",
    Email: "hoikeenauto@hotmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 487,
    Name: "Swee Lee Workshop Sdn Bhd",
    Address:
      "No. 3, Jalan IM 3/7 LTAT Sektor 1,\nBandar Indera Mahkota\n25200\nKuantan\nPahang Darul Makmur",
    Tel: "09- 573 8088\n09- 572 1682\n09- 572 1688",
    Fax: "09- 573 9088",
    Email: "sweelee2005@gmail.com",
    Area: "KUANTAN",
    Status: 1,
    State: "Pahang",
  },
  {
    "Unique ID": 477,
    Name: "Chop Chin Hooi Auto Services Sdn Bhd",
    Address:
      "398A- Jalan Taiping\nOff Jalan Perak\n11600\nPulau Pinang\nPenang (Island)",
    Tel: "04- 281 7542\n04- 281 7544",
    Fax: "04- 281 1542",
    Email: "chinhoois@gmail.com\nchinhoois@hotmail.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 478,
    Name: "Lean Lee Welding & Spray Painting Sdn Bhd",
    Address:
      "1235 Lorong Perusahaan Sg Lokan 5\nKawasan Perindustrian Sg Lokan (ACKU), MK\n16 Bagan Lallang\n13400\nButterworth\nPenang (Seberang Perai)",
    Tel: "04- 310 8686\n04- 310 8688",
    Fax: "04- 310 8687",
    Email: "llwsp@leanlee.com.my",
    Area: "BUTTERWORTH",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 479,
    Name: "Soon Hin Service & Repair Sdn Bhd",
    Address:
      "No. 91-K, Jalan Trusan,\nJelutong Barat, Jelutong,\n10150\nPulau Pinang\nPenang (Island)",
    Tel: "04- 282 8426",
    Fax: "04- 282 1024",
    Email: "soonhinpg@gmail.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 946,
    Name: "PG Leong Car-Body Repairs Sdn Bhd",
    Address:
      "No. 25G, PTN Jalan Osman B Kadir Lit\n10150 Pulau Pinang\nPenang (Island)",
    Tel: "04- 282 8914\n012- 330 6914",
    Fax: "04- 282 8914",
    Email: "pgleong_car60@yahoo.com",
    Area: "PULAU PINANG",
    Status: 1,
    State: "Penang",
  },
  {
    "Unique ID": 488,
    Name: "Syarikat Motor Peak Lik Wong Sdn Bhd",
    Address:
      "K2, Sri Mariamman Lane\nSg. Pari\n30200\nIpoh\nPerak Darul Ridzuan",
    Tel: "05- 243 5555",
    Fax: "05- 241 7332",
    Email: "peaklikwong@gmail.com\npeaklikwong@yahoo.com",
    Area: "IPOH",
    Status: 0,
    State: "Perak",
  },
  {
    "Unique ID": 489,
    Name: "Lau Motor Workshop Menglembu (PK) Sdn Bhd",
    Address:
      "Lot 34627, Jalan Hala Perushaan\nMenglembu 15\nMenglembu\n30200\nIpoh\nPerak Darul Ridzuan",
    Tel: "05- 282 6666",
    Fax: "05- 281 6326",
    Email: "laumotor@gmail.com",
    Area: "IPOH",
    Status: 1,
    State: "Perak",
  },
  {
    "Unique ID": 472,
    Name: "Sin Hup Foh Motor Sdn Bhd",
    Address:
      "Lot 28, Lok Kawi Industrial Estate,\nPhase 2B, Jalan Lama Papar,\n89580\nKota Kinabalu\nSabah",
    Tel: "088- 750 222\n088- 750 226\n088- 750 229",
    Fax: "088- 750 225",
    Email: "hup_foh@hotmail.com",
    Area: "KOTA KINBALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 473,
    Name: "KK Sri Jaya Motor Sdn Bhd",
    Address:
      "Lot 2, Jalan Ramatah- Putatan\nPenampang\n88300\nKota Kinabalu\nSabah",
    Tel: "088- 773 990\n088- 771 989",
    Fax: "088- 772 990",
    Email: "sjmotor@tm.net.my\nsjmotorkk@gmail.com",
    Area: "KOTA KINBALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 945,
    Name: "Yik Sin Auto Sdn Bhd",
    Address:
      "Lot No.2, Lorong Belimbing, Off Jalan Tuaran\nKolombong Mile 5 1/2\n88450 Kota Kinabalu\nSabah",
    Tel: "088- 385 711",
    Fax: "088- 385 712",
    Email: "yucyl555@gmail.com\nyiksinauto@gmail.com",
    Area: "KOTA KINABALU",
    Status: 1,
    State: "Sabah",
  },
  {
    "Unique ID": 474,
    Name: "Ah Seng Motor Sdn Bhd",
    Address:
      "No. 190, 4 1/2 Mile\nJalan Datuk Bandar Mustapha\n93350\nKuching\nSarawak",
    Tel: "082- 456 939\n082- 616 939",
    Fax: "082- 454 619\n082- 616 839",
    Email: "asmkho@pd.jaring.my\nasmo773@gmail.com",
    Area: "KUCHING",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 475,
    Name: "Kiat Seng Welding Works Sdn Bhd",
    Address:
      "Lot 1358, Block 3\nJalan Primula Piasau Industrial Estate\n98000\nMiri\nSarawak",
    Tel: "085- 656 212",
    Fax: "085- 653 212",
    Email: "admin@kiatseng.com.my",
    Area: "MIRI",
    Status: 1,
    State: "Sarawak",
  },
  {
    "Unique ID": 459,
    Name: "Dynamic Auto Service Centre Sdn Bhd",
    Address:
      "Lot 29, Jalan Balakong\nBatu 11 Cheras\n43200\nKajang\nSelangor Darul Ehsan",
    Tel: "03- 9074 0516\n03- 9074 1516",
    Fax: "03- 9074 2516",
    Email: "dasc1388@gmail.com",
    Area: "KAJANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 460,
    Name: "Hikmat Selesa Sdn Bhd",
    Address:
      "Lot 1635, Jalan Haji Tarmidi\nRantau Panjang\n41200\nKlang\nSelangor Darul Ehsan",
    Tel: "03- 3291 2606",
    Fax: "03- 3291 1606",
    Email: "hikmatselesasb@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 461,
    Name: "Lam Koong Sum Car Service Centre Sdn Bhd",
    Address:
      "Lot 11536, Persiaran Ehsan 1\nTaman Impian Ehsan, Jalan Balakong\n43300\nSeri Kembangan\nSelangor Darul Ehsan",
    Tel: "03- 8961 1111",
    Fax: "03- 8961 1437",
    Email: "mrkslam@pc.jaring.my",
    Area: "SERI KEMBANGAN",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 462,
    Name: "Law Tiam Chooi Auto Sdn Bhd",
    Address:
      "13, Jalan SU 26, Taman Selayang Utama\nSelayang\n68100\nBatu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6120 4479, 03- 6137 2858",
    Fax: "03- 6120 2934",
    Email: "ltc_spcom@hotmail.com",
    Area: "BATU CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 463,
    Name: "Maxicergas Sdn Bhd",
    Address:
      "No.5, Jalan SBC 10,\nTaman Sri Batu Caves\n68100\nBatu Caves\nSelangor Darul Ehsan",
    Tel: "03- 6189 2255",
    Fax: "03- 6189 9889",
    Email: "maxicgsb@gmail.com\nmaxicgsb@yahoo.com",
    Area: "CAVES",
    Status: 0,
    State: "Selangor",
  },
  {
    "Unique ID": 464,
    Name: "Rawang Yee Motor Sdn Bhd",
    Address:
      "Lot 1 , Jalan Perindustrian 1\nKawasan Perindustrian PKNS ,Batu 20\n48000\nRawang\nSelangor Darul Ehsan",
    Tel: "03- 6091 6250\n012-221 6250\n012-335 6250",
    Fax: "03- 6092 6250",
    Email: "claim@rwyeemotor.com",
    Area: "RAWANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 466,
    Name: "Soon Fatt Heng Motor Sdn Bhd",
    Address: "No. 2A, Jalan Kilang\n46050\nPetaling Jaya\nSelangor Darul Ehsan",
    Tel: "03- 7781 5468\n03- 7781 5467",
    Fax: "03- 7783 2536",
    Email: "motorsoonfattheng@yahoo.com",
    Area: "PETALING JAYA",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 467,
    Name: "SCS Auto Repair Sdn Bhd",
    Address:
      "87, Jalan Pendamar\n27/90, Section 27\n40400\nShah Alam\nSelangor Darul Ehsan",
    Tel: "03- 5103 6928\n03- 5192 8906 (Account Department)",
    Fax: "03- 5192 9726",
    Email: "scsautorepairsb@gmail.com",
    Area: "SHAH ALAM",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 468,
    Name: "Shiun Motor Sdn Bhd",
    Address:
      "Lot 6, Jalan PBI 2\nPerindustrian Bukit Indah\n47000\nSungai Buloh\nSelangor Darul Ehsan",
    Tel: "03- 6143 1551\n03- 6143 1661\n03- 6143 1771\n03- 6143 1991",
    Fax: "03- 6143 1221",
    Email: "shiunmotor@yahoo.com.my",
    Area: "SUNGAI BULOH",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 469,
    Name: "New Thong Hing Motor Sdn Bhd",
    Address:
      "Lot 17502, Jalan 4\nTaman Selayang Baru Industrial Area\n68100, Batu Caves\nSelangor",
    Tel: "03- 6125 2828",
    Fax: "03- 6136 3639",
    Email: "newthmotor@gmail.com",
    Area: "BATU CAVES",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 470,
    Name: "Utama Motor Workshop ( Selangor ) Sdn Bhd",
    Address:
      "Lot 8860. Jalan Kim Chuan\nPandamaran\n42000\nKlang\nSelangor Darul Ehsan",
    Tel: "03- 3166 1999\n03- 3165 8820",
    Fax: "03- 3168 5229",
    Email: "umwssb@gmail.com",
    Area: "KLANG",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 471,
    Name: "Weng Oon Auto Sdn Bhd",
    Address:
      "50, Jalan Mas Jaya 2, Kawasan\nPerindustrian Mas Jaya, Off Jalan Hulu\nLangat\n43200\nCheras\nSelangor Darul Ehsan",
    Tel: "03- 9075 1133",
    Fax: "03- 9076 7068",
    Email: "mah@wengoon.com.my\nsherene@wengoon.com.my",
    Area: "CHERAS",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 944,
    Name: "Poh Kin Motor Works Sdn Bhd",
    Address:
      "No. 2872. Jalan Ipoh. Batu 30\nUlu Yam Lama\n44300 Batang Kali\nSelangor Darul Ehsan",
    Tel: "03- 6075 1106",
    Fax: "03- 6075 2106",
    Email: "pkmwtlt@yahoo.com",
    Area: "BATANG KALI",
    Status: 1,
    State: "Selangor",
  },
  {
    "Unique ID": 458,
    Name: "Yoong Lee Car-Tech Sdn Bhd",
    Address:
      "T 2138K, Kawasan Perindustrian\nChendering\n21080\nKuala Terengganu\nTerengganu Darul Iman",
    Tel: "09- 9171 407\n09- 6172 407",
    Fax: "09- 6175 407",
    Email: "yoonglee01@yahoo.com.my",
    Area: "KUALA TERENGGANU",
    Status: 1,
    State: "Terengganu",
  },
];
